import { API } from "aws-amplify";
import { getProperty } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_PROPERTY: APITypes.Property = {
  id: "",
  name: "",
  city: "",
  state: "",
  country: "",
  zipCode: "",
  poBox: "",
  userID: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  description: "",
  areaSize: "",
  contact: "",
  expectedRentPaymentDate: "",
  __typename: "Property",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getPropertyDetails = async (propertyID: string) => {
  try {
    const response = (await API.graphql({
      query: getProperty,
      variables: {
        id: propertyID,
      },
    })) as { data?: APITypes.GetPropertyQuery };

    return {
      success: true,
      data: response.data?.getProperty || EMPTY_PROPERTY,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_PROPERTY,
      error,
    };
  }
};
